export const DailyLogQuizLogEvent = {
  // [로그 퀴즈] 화면 진입
  DAILY_LOG_QUIZ_VIEWED: { amp: 'Daily Log Quiz - Viewed', ga: 'daily_log_quiz_visit' },
  // [로그 퀴즈] 나도 퀴즈 만들기 버튼 클릭
  DAILY_LOG_QUIZ_CREATE_BUTTON_CLICKED: {
    amp: 'Daily Log Quiz - Create Button Clicked',
    ga: 'daily_log_quiz_click_create',
  },
  // [로그 퀴즈] 프로필 방문 클릭
  DAILY_LOG_QUIZ_VISIT_PROFILE_CLICKED: {
    amp: 'Daily Log Quiz - Visit Profile Clicked',
    ga: 'daily_log_quiz_visit_profile',
  },
  // [로그 퀴즈] 답글 달기 클릭
  DAILY_LOG_QUIZ_REPLY_BUTTON_CLICKED: {
    amp: 'Daily Log Quiz - Reply Button Clicked',
    ga: 'daily_log_quiz_click_reply',
  },
  // [로그 퀴즈] 좋아요 클릭
  DAILY_LOG_QUIZ_LIKE_BUTTON_CLICKED: { amp: 'Daily Log Quiz - Like Button Clicked', ga: 'daily_log_quiz_click_like' },
  // [로그 퀴즈] 앱 설치 모달 - 노출
  DAILY_LOG_QUIZ_APP_INSTALL_MODAL_VIEWED: {
    amp: 'Daily Log Quiz - App Install Modal Viewed',
    ga: 'daily_log_quiz_app_install_modal_viewed',
  },
  // [로그 퀴즈] 앱 설치 모달 버튼 클릭
  DAILY_LOG_QUIZ_APP_INSTALL_MODAL_BUTTON_CLICKED: {
    amp: 'Daily Log Quiz - App Install Modal Button Clicked',
    ga: 'daily_log_quiz_app_install_modal_button_clicked',
  },
  // [웹][로그 퀴즈] - 투표하기 버튼 클릭
  DAILY_LOG_QUIZ_VOTE_BUTTON_CLICKED: { amp: 'Daily Log Quiz - Vote Button Clicked', ga: 'daily_log_quiz_click_vote' },
  // [웹][로그 퀴즈] - 빈칸 입력하기 버튼 클릭
  DAILY_LOG_QUIZ_INPUT_BUTTON_CLICKED: {
    amp: 'Daily Log Quiz - Input Button Clicked',
    ga: 'daily_log_quiz_click_input',
  },
  // [웹][로그 퀴즈] - 내 투표 결과 클릭
  DAILY_LOG_QUIZ_MY_VOTE_CLICKED: { amp: 'Daily Log Quiz - My Vote Clicked', ga: 'daily_log_quiz_click_my_vote' },
  // [웹][로그 퀴즈 빈칸 입력하기] - 화면 진입
  DAILY_LOG_QUIZ_INPUT_VIEWED: { amp: 'Daily Log Quiz - Input Viewed', ga: 'daily_log_quiz_input_visit' },
  // [웹][로그 퀴즈 빈칸 입력하기] - 완료 버튼 클릭
  DAILY_LOG_QUIZ_INPUT_SUBMITTED: { amp: 'Daily Log Quiz - Input Submitted', ga: 'daily_log_quiz_input_submit' },
  // [웹][로그 퀴즈 로그인 모달] - 진입
  DAILY_LOG_QUIZ_LOGIN_MODAL_VIEWED: {
    amp: 'Daily Log Quiz - Login Modal Viewed',
    ga: 'daily_log_quiz_login_modal_viewed',
  },
  // [웹][로그 퀴즈 로그인 모달] - 카카오 로그인 클릭
  DAILY_LOG_QUIZ_LOGIN_KAKAO_CLICKED: {
    amp: 'Daily Log Quiz - Login Modal - Kakao Clicked',
    ga: 'daily_log_quiz_login_modal_click_kakao',
  },
  // [웹][로그 퀴즈 로그인 모달] - 비회원 참여 클릭
  DAILY_LOG_QUIZ_LOGIN_NON_MEMBER_CLICKED: {
    amp: 'Daily Log Quiz - Login Modal - Non Member Clicked',
    ga: 'daily_log_quiz_login_modal_click_non_member',
  },
  // [웹][로그 퀴즈 닉네임 모달] - 진입
  DAILY_LOG_QUIZ_NICKNAME_MODAL_VIEWED: {
    amp: 'Daily Log Quiz - Nickname Modal Viewed',
    ga: 'daily_log_quiz_nickname_modal_viewed',
  },
  // [웹][로그 퀴즈 닉네임 모달] - submit
  DAILY_LOG_QUIZ_NICKNAME_MODAL_SUBMITTED: {
    amp: 'Daily Log Quiz - Nickname Modal Submitted',
    ga: 'daily_log_quiz_nickname_modal_submit',
  },
  // [웹] 다른 친구들의 응답 내용 확인 배너 클릭
  DAILY_LOG_QUIZ_OTHER_FRIENDS_RESPONSE_BANNER_CLICKED: {
    amp: 'Daily Log Quiz - Other Friends Response Banner Clicked',
    ga: 'daily_log_quiz_other_friends_response_banner_click',
  },

  //로그 퀴즈 리스트 - 화면 진입
  DAILY_LOG_QUIZ_LIST_SCREEN_VIEWED: {
    ga: 'daily_log_quiz_list_screen_viewed',
    amp: 'Daily Log Quiz List - Screen Viewed',
  },
  // 로그 퀴즈 리스트 - 공유 노출
  DAILY_LOG_QUIZ_LIST_SHARE_VIEWED: {
    ga: 'daily_log_quiz_list_share_viewed',
    amp: 'Daily Log Quiz List - Share Viewed',
  },
  // 로그 퀴즈 리스트 - 공유 클릭
  DAILY_LOG_QUIZ_LIST_SHARE_CLICKED: {
    ga: 'daily_log_quiz_list_share_clicked',
    amp: 'Daily Log Quiz List - Share Clicked',
  },

  // [웹] 로그 퀴즈 랜딩 화면 진입
  DAILY_LOG_QUIZ_LANDING_VIEWED: {
    ga: 'daily_log_quiz_landing_viewed',
    amp: 'Daily Log Quiz Landing - Viewed',
  },
  // [웹] 로그 퀴즈 랜딩 화면 - 로그인 클릭
  DAILY_LOG_QUIZ_LANDING_LOGIN_CLICKED: {
    ga: 'daily_log_quiz_landing_login_clicked',
    amp: 'Daily Log Quiz Landing - Login Clicked',
  },
  // [웹] 로그 퀴즈 리스트 - 응답 알림 받기 배너 클릭
  DAILY_LOG_QUIZ_LIST_NOTIFICATION_BANNER_CLICKED: {
    ga: 'daily_log_quiz_list_notification_banner_clicked',
    amp: 'Daily Log Quiz List - Notification Banner Clicked',
  },
  // [웹] 로그 상세 - 응답 알림 받기 배너 클릭
  DAILY_LOG_QUIZ_DETAIL_NOTIFICATION_BANNER_CLICKED: {
    ga: 'daily_log_quiz_detail_notification_banner_clicked',
    amp: 'Daily Log Quiz Detail - Notification Banner Clicked',
  },
  // [웹] 로그 상세 - 응답 수정 배너 클릭
  DAILY_LOG_QUIZ_DETAIL_EDIT_BANNER_CLICKED: {
    ga: 'daily_log_quiz_detail_edit_banner_clicked',
    amp: 'Daily Log Quiz Detail - Edit Banner Clicked',
  },
  // [웹] 로그 퀴즈 공유
  DAILY_LOG_QUIZ_SHARE_CLICKED: {
    ga: 'daily_log_quiz_share_clicked',
    amp: 'Daily Log Quiz - Share Clicked',
  },
  // 이하 로그 퀴즈 만들기는 객관식만 보여줌
  // [웹] 로그 퀴즈 만들기 화면 진입
  DAILY_LOG_QUIZ_CREATE_VIEWED: {
    ga: 'daily_log_quiz_create_viewed',
    amp: 'Daily Log Quiz Create - Viewed',
  },
  // [웹] 로그 퀴즈 만들기 화면 - 주제 변경 클릭
  DAILY_LOG_QUIZ_CREATE_CHANGE_TEMPLATE_CLICKED: {
    ga: 'daily_log_quiz_create_change_template_clicked',
    amp: 'Daily Log Quiz Create - Change Template Clicked',
  },
  // [웹] 로그 퀴즈 만들기 화면 - 투표 완료 클릭
  DAILY_LOG_QUIZ_CREATE_VOTE_COMPLETED_CLICKED: {
    ga: 'daily_log_quiz_create_vote_completed_clicked',
    amp: 'Daily Log Quiz Create - Vote Completed Clicked',
  },
  // [웹] 로그 퀴즈 만들기 화면 - 내가 만든 질문 보기
  DAILY_LOG_QUIZ_CREATE_MY_QUESTION_CLICKED: {
    ga: 'daily_log_quiz_create_my_question_clicked',
    amp: 'Daily Log Quiz Create - My Question Clicked',
  },
  // [웹] 로그 퀴즈 만들기 화면 - 앱에서 보기 클릭
  DAILY_LOG_QUIZ_CREATE_OPEN_APP_CLICKED: {
    ga: 'daily_log_quiz_create_open_app_clicked',
    amp: 'Daily Log Quiz Create - Open App Clicked',
  },
  // [웹] 로그 퀴즈 상세 - 친구 응답 클릭
  DAILY_LOG_QUIZ_DETAIL_FRIEND_ANSWER_CLICKED: {
    ga: 'daily_log_quiz_detail_friend_answer_clicked',
    amp: 'Daily Log Quiz Detail - Friend Answer Clicked',
  },
  // 로그 퀴즈 홈 - 주제 모아보기 배너 버튼 클릭
  DAILY_LOG_QUIZ_TEMPLATE_LIST_FILTER_CLICKED: {
    ga: 'daily_log_quiz_template_list_filter_clicked',
    amp: 'Daily Log Quiz Template List - Filter Clicked',
  },
  // 로그 퀴즈 홈 - 주제 모아보기 배너 버튼 클릭
  DAILY_LOG_QUIZ_HOME_SHOW_ALL_TEMPLATE_BANNER_BUTTON_CLICKED: {
    ga: 'daily_log_quiz_home_show_all_banner_button_clicked',
    amp: 'Daily Log Quiz Home - Show All Template Banner Button Clicked',
  },
}
